import {
  DepressionContentPage,
  FAQItem,
} from "@/components/DepressionContentPage";
import { RelatedLink } from "@/components/RelatedPages";

interface ArticleProps {
  slug: string;
  title: string;
  description: string;
  keywords: string;
  badge: string;
  heroTitle: string;
  heroSubtitle: string;
  sections: { heading?: string; body: string; callout?: boolean }[];
  faq?: FAQItem[];
  related?: RelatedLink[];
  finalCtaText?: string;
}

export const buildArticle = (props: ArticleProps) => {
  const Component = () => (
    <DepressionContentPage
      seo={{
        title: `${props.title} | Neuro Wellness TMS`,
        description: props.description,
        canonical: `/${props.slug}`,
        keywords: props.keywords,
      }}
      badge={props.badge}
      heroTitle={props.heroTitle}
      heroSubtitle={props.heroSubtitle}
      sections={props.sections.map((s) => ({
        heading: s.heading,
        variant: s.callout ? "callout" : "text",
        body: <p>{s.body}</p>,
        callout: s.callout ? s.body : undefined,
      }))}
      faq={props.faq}
      relatedLinks={props.related}
      finalCtaText={props.finalCtaText}
    />
  );
  return Component;
};
